export const arabicFlashcards = {
  categories: [
    {
      ar: "السلام عليكم",
      rm: "As-salamu alaykum",
      en: "Peace be upon you (greeting)",
    },
    {
      ar: "وعليكم السلام",
      rm: "Wa alaykum as-salam",
      en: "And upon you be peace (response)",
    },
    {
      ar: "أهلاً",
      rm: "Ahlan",
      en: "Hello (general)",
    },
    {
      ar: "مرحبا",
      rm: "Marhaba",
      en: "Hello (more formal)",
    },
    {
      ar: "صباح الخير",
      rm: "Sabah al-khair",
      en: "Good morning",
    },
    {
      ar: "مساء الخير",
      rm: "Masa' al-khair",
      en: "Good evening",
    },
    {
      ar: "مع السلامة",
      rm: "Ma'a as-salama",
      en: "Goodbye",
    },
    {
      ar: "إلى اللقاء",
      rm: "Ila al-liqa'",
      en: "Goodbye / See you later",
    },
    {
      ar: "شكراً",
      rm: "Shukran",
      en: "Thank you",
    },
    {
      ar: "شكراً جزيلاً",
      rm: "Shukran jazilan",
      en: "Thank you very much",
    },
    {
      ar: "عفواً",
      rm: "Afwan",
      en: "You're welcome / Excuse me",
    },
    {
      ar: "من فضلك",
      rm: "Min fadlik (m) / Min fadlik (f)",
      en: "Please (to a man/woman)",
    },
    {
      ar: "نعم",
      rm: "Na'am",
      en: "Yes",
    },
    {
      ar: "لا",
      rm: "La",
      en: "No",
    },
    {
      ar: "حسناً",
      rm: "Hasanan",
      en: "Okay / Alright",
    },
    {
      ar: "أنا لا أفهم",
      rm: "Ana la afham",
      en: "I don't understand",
    },
    {
      ar: "هل تتكلم الإنجليزية؟",
      rm: "Hal tatakallam al-ingliziyya?",
      en: "Do you speak English? (formal)",
    },
    {
      ar: "إزيك؟",
      rm: "Izzayak? (m) / Izzayik? (f)",
      en: "How are you? (Egyptian, informal to a man/woman)",
    },
    {
      ar: "كيف حالك؟",
      rm: "Kayfa haluk? (m) / Kayfa haluki? (f)",
      en: "How are you? (more formal to a man/woman)",
    },
    {
      ar: "أنا بخير، شكراً",
      rm: "Ana bikhair, shukran",
      en: "I'm fine, thank you",
    },
    {
      ar: "ما اسمك؟",
      rm: "Ma ismuk? (m) / Ma ismuki? (f)",
      en: "What's your name? (formal to a man/woman)",
    },
    {
      ar: "اسمي...",
      rm: "Ismi...",
      en: "My name is...",
    },
    {
      ar: "كم هذا؟",
      rm: "Kam hatha?",
      en: "How much is this?",
    },
    {
      ar: "غالي جداً",
      rm: "Ghali jiddan",
      en: "Very expensive",
    },
    {
      ar: "أين...؟",
      rm: "Ayna...?",
      en: "Where is...?",
    },
    {
      ar: "أين الحمام؟",
      rm: "Ayna al-hammam?",
      en: "Where is the bathroom?",
    },
    {
      ar: "أين محطة القطار؟",
      rm: "Ayna mahattat al-qitar?",
      en: "Where is the train station?",
    },
    {
      ar: "أين المطار؟",
      rm: "Ayna al-matar?",
      en: "Where is the airport?",
    },
    {
      ar: "ساعدني!",
      rm: "Sa'idni!",
      en: "Help me!",
    },
    {
      ar: "أحتاج مساعدة",
      rm: "Ahtaju musa'ada",
      en: "I need help",
    },
    {
      ar: "أنا تائه",
      rm: "Ana ta'ih (m) / Ana ta'iha (f)",
      en: "I am lost (male/female)",
    },
    {
      ar: "هل يمكنك مساعدتي؟",
      rm: "Hal yumkinuk musa'adati?",
      en: "Can you help me?",
    },
    {
      ar: "تكلم ببطء من فضلك",
      rm: "Takallam bibut' min fadlik (m) / Takallam bibut' min fadlik (f)",
      en: "Speak slowly, please (to a man/woman)",
    },
    {
      ar: "كرر من فضلك",
      rm: "Karrir min fadlik (m) / Karrir min fadlik (f)",
      en: "Repeat, please (to a man/woman)",
    },
    {
      ar: "أنا مريض",
      rm: "Ana marid (m) / Ana marida (f)",
      en: "I am sick (male/female)",
    },
    {
      ar: "أحتاج طبيب",
      rm: "Ahtaju tabib",
      en: "I need a doctor",
    },
    {
      ar: "أريد هذا",
      rm: "Urid hatha",
      en: "I want this",
    },
    {
      ar: "لا أريد هذا",
      rm: "La urid hatha",
      en: "I don't want this",
    },
    {
      ar: "جيد",
      rm: "Jayyid",
      en: "Good",
    },
    {
      ar: "جيد جداً",
      rm: "Jayyid jiddan",
      en: "Very good",
    },
    {
      ar: "سيء",
      rm: "Sayyi'",
      en: "Bad",
    },
    {
      ar: "اليوم",
      rm: "Al-yawm",
      en: "Today",
    },
    {
      ar: "غداً",
      rm: "Ghadan",
      en: "Tomorrow",
    },
    {
      ar: "أمس",
      rm: "Ams",
      en: "Yesterday",
    },
    {
      ar: "الآن",
      rm: "Al-aan",
      en: "Now",
    },
    {
      ar: "لاحقاً",
      rm: "Lahiqan",
      en: "Later",
    },
    {
      ar: "ماء",
      rm: "Ma'",
      en: "Water",
    },
    {
      ar: "طعام",
      rm: "Ta'am",
      en: "Food",
    },
    {
      ar: "شاي",
      rm: "Shay",
      en: "Tea",
    },
    {
      ar: "قهوة",
      rm: "Qahwa",
      en: "Coffee",
    },
    {
      ar: "بيرة",
      rm: "Bira",
      en: "Beer",
    },
    {
      ar: "كم الوقت؟",
      rm: "Kam al-waqt?",
      en: "What time is it?",
    },
    {
      ar: "جواز سفر",
      rm: "Jawaz safar",
      en: "Passport",
    },
    {
      ar: "تأشيرة",
      rm: "Ta'shira",
      en: "Visa",
    },
    {
      ar: "فندق",
      rm: "Funduq",
      en: "Hotel",
    },
    {
      ar: "غرفة",
      rm: "Ghurfa",
      en: "Room",
    },
    {
      ar: "أريد حجز غرفة",
      rm: "Urid hajz ghurfa",
      en: "I want to book a room",
    },
    {
      ar: "هذا جيد جداً",
      rm: "Hatha jayyid jiddan",
      en: "This is very good",
    },
    {
      ar: "لا توجد مشكلة",
      rm: "La tujad mushkila",
      en: "No problem",
    },
    {
      ar: "حظ سعيد!",
      rm: "Hazz sa'id!",
      en: "Good luck!",
    },
    {
      ar: "استمتع!",
      rm: "Istamti'!",
      en: "Have fun!",
    },
    {
      ar: "إلى اليمين",
      rm: "Ila al-yamin",
      en: "To the right",
    },
    {
      ar: "إلى اليسار",
      rm: "Ila al-yasar",
      en: "To the left",
    },
    {
      ar: "مستقيم",
      rm: "Mustaqim",
      en: "Straight",
    },
    {
      ar: "قريب",
      rm: "Qarib",
      en: "Near",
    },
    {
      ar: "بعيد",
      rm: "Ba'id",
      en: "Far",
    },
    {
      ar: "كم يستغرق من الوقت؟",
      rm: "Kam yastaghriqu min al-waqt?",
      en: "How long does it take?",
    },
    {
      ar: "أنا جائع",
      rm: "Ana ja'i' (m) / Ana ja'i'a (f)",
      en: "I am hungry (male/female)",
    },
    {
      ar: "أنا عطشان",
      rm: "Ana 'atshan (m) / Ana 'atshana (f)",
      en: "I am thirsty (male/female)",
    },
    {
      ar: "هذا حلال؟",
      rm: "Hatha halal?",
      en: "Is this halal?",
    },
    {
      ar: "تهانينا!",
      rm: "Tahani'na!",
      en: "Congratulations!",
    },
    {
      ar: "ماذا تفعل؟",
      rm: "Matha taf'al? (m) / Matha taf'alina? (f)",
      en: "What are you doing? (to a man/woman)",
    },
    {
      ar: "أنا آسف",
      rm: "Ana asif (m) / Ana asifa (f)",
      en: "I am sorry (male/female)",
    },
    {
      ar: "تفضل",
      rm: "Tafaddal (m) / Tafaddali (f)",
      en: "Please come in / Here you are (to a man/woman)",
    },
    {
      ar: "تفضلوا",
      rm: "Tafaddalu",
      en: "Please come in (to a group)",
    },
    {
      ar: "على الرحب والسعة",
      rm: "Ala ar-rahbi was-sa'a",
      en: "You're very welcome",
    },
    {
      ar: "لا شكر على واجب",
      rm: "La shukr ala wajib",
      en: "Don't mention it / It was my pleasure",
    },
    {
      ar: "أنا نباتي",
      rm: "Ana nabati (m) / Ana nabatiyya (f)",
      en: "I am vegetarian (male/female)",
    },
    {
      ar: "هل هذا مجاني؟",
      rm: "Hal hatha majjani?",
      en: "Is this free?",
    },
    {
      ar: "ما هي كلمة مرور الواي فاي؟",
      rm: "Ma hiya kalimat murur al-wai fai?",
      en: "What is the wifi password?",
    },
    {
      ar: "هل يمكنني التقاط صورة؟",
      rm: "Hal yumkinuni iltiqat sura?",
      en: "Can I take a picture?",
    },
    {
      ar: "ما هذا؟",
      rm: "Ma hatha?",
      en: "What is this?",
    },
    {
      ar: "أعجبني هذا",
      rm: "A'jabani hatha",
      en: "I like this",
    },
    {
      ar: "لم يعجبني هذا",
      rm: "Lam yu'jibni hatha",
      en: "I don't like this",
    },
    {
      ar: "رائع!",
      rm: "Ra'i'!",
      en: "Wonderful! / Great!",
    },
    {
      ar: "يا للأسف!",
      rm: "Ya lil-asaf!",
      en: "What a pity!",
    },
    {
      ar: "هذا يكفي",
      rm: "Hatha yakfi",
      en: "That's enough",
    },
    {
      ar: "انتظر لحظة",
      rm: "Intazir lahza",
      en: "Wait a moment",
    },
    {
      ar: "لا تلمسني",
      rm: "La talmasni",
      en: "Don't touch me!",
    },
  ],
};
